import { ParsedBlocklistRecord } from "@whatslly/types/messages-server/messages";

export const isPhoneBlocked = (blockedPhones: ParsedBlocklistRecord[] | string[], senderPhone: string, receiverPhone: string): boolean => {
  const phones = blockedPhones
    ?.filter((p) => typeof p === "string" || !p?.isInternal)
    .map((p) => (typeof p === "string" ? p : p.phone));
  const internalPhones = blockedPhones?.filter((p) => typeof p !== "string" && p.isInternal) as ParsedBlocklistRecord[];
  const isBlockedPhone = phones?.includes(receiverPhone) || phones?.includes(senderPhone);
  const isInternalConversation = internalPhones.some((p) => p.phone === receiverPhone) && internalPhones.some((p) => p.phone === senderPhone);
  return isBlockedPhone || isInternalConversation;
};
